<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visible = true"
        >
          新增业务模式
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <template v-if="tableRow.freeze === 0">
              <a-button type="link" size="small" @click="handleEdit(tableRow)">
                编辑
              </a-button>
              <a-divider type="vertical" />
            </template>

            <template v-if="tableRow.freeze === 0">
              <a-popconfirm
                title="此操作将删除该项信息, 是否继续?"
                @confirm="handleDeleteConfirm(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">
                  删除
                </a-button>
              </a-popconfirm>
              <a-divider type="vertical" />
            </template>

            <template v-if="tableRow.freeze === 0">
              <a-popconfirm
                title="此操作将冻结该业务类型, 是否继续?"
                @confirm="handleFreeze(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">
                  冻结
                </a-button>
              </a-popconfirm>
            </template>

            <template v-if="tableRow.freeze === 1">
              <a-popconfirm
                title="此操作将解冻该业务类型, 是否继续?"
                @confirm="handleThaw(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">
                  解冻
                </a-button>
              </a-popconfirm>
            </template>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
      width="800px"
    >
      <a-form :form="modalForm">
        <a-form-item label="所属业务类型">
          <a-select
            v-decorator="$decorator('pid', '请选择所属业务类型')"
            @focus="handleFocus"
          >
            <a-select-option
              v-for="item in selectList"
              :key="item.value"
              :disabled="item.disabled"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="业务模式">
          <a-input
            :maxLength="100"
            allowClear
            v-decorator="$decorator('name', '业务模式不能为空')"
          ></a-input>
        </a-form-item>
        <contact-form
          @getData="getIntervalData"
          :id="id"
          ref="mychild"
        ></contact-form>
        <br />
        <term-rules
          @getData="getTermData"
          :id="id"
          ref="termchild"
        ></term-rules>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import ContactForm from './components/ContactForm'
import TermRules from './components/TermRules'
import {
  add,
  remove,
  getBusinessTypeList,
  getTableData,
  freeze,
  thaw,
  getFreezeBgList,
} from 'views/setting/api'

export default {
  mixins: [mixin],
  data() {
    return {
      searchCardLoading: true,
      tableLoading: true,
      visible: false,
      modalForm: this.$form.createForm(this),
      modalTitle: '新增',
      selectList: [],
      rules: [],
      termRules: [],
      id: '',
      syList: [], //BG冻结
    }
  },
  components: {
    SearchView,
    TableView,
    ContactForm,
    TermRules,
  },
  mounted() {
    this._getTableData()
    this._getBusinessTypeList()
    this._getFreezeBgList()
  },
  methods: {
    handleFocus() {
      if (this.selectList) {
        this.selectList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.selectList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.value === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },

    getIntervalData(data) {
      this.rules = data
    },
    getTermData(data) {
      this.termRules = data
    },
    // 获取业务类型数据
    _getBusinessTypeList() {
      getBusinessTypeList().then(({ data }) => {
        this.selectList = data.map(item => {
          return {
            text: item.name,
            value: item.id,
          }
        })
        this.searchSchema[0].selectList = [...this.selectList]
      })
    },
    _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },
    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
        type: 3,
      }

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    // 提交和编辑
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }
          if (this.rules.length == 0) {
            this.$message.warn('至少写一条信用限额审批规则')
            return false
          }
          var submitRules = []
          for (let item of this.rules) {
            for (let key in item) {
              if (key !== 'id' && item[key] === '') {
                this.$notification.error({
                  message: '提示',
                  description: '信用限额审批规则不可以空',
                })
                return false
              }
            }
            submitRules.push({
              creditLevel: item.creditLevel,
              id: item.id,
              ruleType: 1,
              max: item.max,
              maxEqual: item.maxEqual,
              min: item.min,
              minEqual: item.minEqual,
            })
          }
          if (this.termRules.length == 0) {
            this.$message.warn('至少写一条账期审批规则')
            return false
          }
          var submitTermRules = []
          for (let term of this.termRules) {
            for (let key in term) {
              if (key !== 'id' && term[key] === '') {
                this.$notification.error({
                  message: '提示',
                  description: '信用限额审批规则不可以空',
                })
                return false
              }
            }
            submitTermRules.push({
              creditLevel: term.creditLevel,
              ruleType: 2,
              id: term.id,
              max: term.max,
              maxEqual: term.maxEqual,
              min: term.min,
              minEqual: term.minEqual,
            })
          }
          try {
            const { message } = await add({
              ...values,
              modelRules: submitRules,
              termRules: submitTermRules,
              id: this.id,
              type: 3,
            })
            this.visible = false

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.id = ''
      this.modalTitle = '新增'
    },
    // 点击编辑
    async handleEdit(tableRow) {
      const { name, id, pid } = tableRow
      this.id = id
      this.visible = true
      this.modalTitle = '编辑'
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          name,
          pid,
        })
        this.id = id
        this.$refs.mychild.query()
        this.$refs.termchild.query()
      }, 20)
    },
    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    //冻结
    handleFreeze({ id }) {
      freeze(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },

    //解冻
    handleThaw({ id }) {
      thaw(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
  },
}
</script>
